import { IVerifiable } from './types'

export function isVerified(obj: IVerifiable): boolean {
    return obj && obj.isVerified
}